import type { GridFilterModel } from '@mui/x-data-grid-pro';

export const DEFAULT_FILTER_MODEL: GridFilterModel = {
  items: [],
  logicOperator: 'and' as GridFilterModel['logicOperator'],
};
